var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-placeholder grid grid__placeholder" }, [
    _c(
      "div",
      { staticClass: "grid--container main-placeholder--container" },
      [
        _c(
          "transition-group",
          {
            staticClass: "grid--row main-placeholder--row",
            attrs: { name: "trs-simple-fade", tag: "div" }
          },
          [
            _vm.pageTitle
              ? _c(
                  "div",
                  {
                    key: "pageTitle",
                    staticClass:
                      "grid--col grid--col__page-title main-placeholder--col"
                  },
                  [
                    _c("h1", {
                      domProps: { textContent: _vm._s(_vm.pageTitle) }
                    })
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.plugins, function(plugin, pluginIdx) {
              return !_vm.isLoading
                ? _c(plugin.type, {
                    key: pluginIdx,
                    tag: "component",
                    staticClass: "grid--col main-placeholder--col",
                    attrs: { plugin: plugin }
                  })
                : _vm._e()
            })
          ],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64502ddc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64502ddc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./vehi-industriepfad/assets/src/js/app/framework/components/cms-placeholders/main-placeholder/index.vue
// module id = 247
// module chunks = 5